import React from 'react';
import { Typography, Stack, Box, Chip, Divider } from '@mui/material';
import moment from 'moment';

import { ISubmissionQuestion } from '../../../../store/SubmissionSlice';
import { IQuestion } from '../../../../store/QuestionSlice';

const labelStyles: React.CSSProperties = {
  borderRadius: '4px',
  fontWeight: 600,
  marginRight: '5px',
};

export interface IGradedSection {
  selectedQuestion: ISubmissionQuestion;
  questionData: IQuestion;
}

const GradedSection: React.FC<IGradedSection> = ({
  selectedQuestion,
  questionData,
}) => {
  const isGraded = () => {
    if (
      typeof selectedQuestion.openEnded?.score === 'number' &&
      selectedQuestion.openEnded?.score >= 0
    ) {
      return true;
    }
    return false;
  };

  const getGradeColor = () => {
    if (typeof selectedQuestion.openEnded?.score === 'number') {
      if (selectedQuestion.openEnded?.score > 0) {
        return 'success.main';
      }

      return 'error.main';
    }

    return 'warning.main';
  };

  const getGradeStatus = () => {
    if (isGraded()) {
      return `Graded : ${(selectedQuestion.openEnded?.score || 0)
        .toString()
        .padStart(2, '0')} / ${questionData.marks
        .toString()
        .padStart(2, '0')} Mark(s)`;
    }

    if (selectedQuestion.openEnded?.answer) {
      return 'Marks Pending : awaiting tutor’s assessment.';
    }

    return 'Skipped question: No marks.';
  };

  return (
    <Box style={{ padding: '16px' }}>
      <Stack direction="row" justifyContent="flex-end">
        <Typography
          variant="subtitle2"
          fontWeight="600"
          color={getGradeColor()}
        >
          {getGradeStatus()}
        </Typography>
      </Stack>

      {selectedQuestion.openEnded?.comment && (
        <>
          <Stack direction="row" alignItems="center" marginBottom="10px">
            <Typography
              variant="subtitle2"
              fontWeight="600"
              style={{ marginRight: '12px' }}
            >
              {selectedQuestion.openEnded?.gradedBy || ''}
            </Typography>
            <Typography color="secondary" variant="body2" fontWeight="600">
              {moment(selectedQuestion.openEnded?.gradedAt).format(
                'DD-MM-YYYY hh:mm A'
              )}
            </Typography>
          </Stack>
          <Typography color="secondary" variant="body2">
            {selectedQuestion.openEnded?.comment}
          </Typography>
          <Divider sx={{ margin: '20px 0' }} />
        </>
      )}
      {selectedQuestion.openEnded?.openAiComment && (
        <>
          <Chip label="Marked by OpenAI" style={labelStyles} />
          <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: selectedQuestion.openEnded?.openAiComment,
            }}
          />
        </>
      )}
    </Box>
  );
};

export default GradedSection;
